import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Heading,
  Button,
  SmartForm,
  Status,
  Dropdown,
  Link,
  Tooltip,
  InputGroup,
  InputsRow,
  Label,
  SmartInput,
} from 'components';

import classNames from 'classnames/bind';
import { maskedPhone } from 'utils/validators';
import AddressWrapper from '../AdressWrapper';

import Ctx from '../../formText';

import { makeFormData } from '../../selectors/form';
import { SET_ALLINONE_VALUE } from '../../../../constants';
import { sendRequiest } from '../../../../actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class FormWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isPhonePushed: false,
      selectedAddress: 'default',
      regionStatus: 'ok',
      streetStatus: 'ok',
      houseStatus: 'ok',
      flatStatus: 'ok',
      orderBtnClicked: false,
    };
  }

    onOrderClick = () => {
      this.setState({ orderBtnClicked: true });
    };

    getSelectedAddressType = (withoutInternet, address, selectedAddress) => {
      if (withoutInternet) {
        return 'New';
      }
      if (typeof address === 'object' && address !== null && selectedAddress === 'default') {
        return 'ExistingAuth';
      }
      return 'Existing';
    };

    getHeader = (address) => {
      if (address) {
        return 'Выберите адрес подключения';
      }
      return 'Введите ваш логин — номер лицевого счета, указанный в договоре';
    };

    pushEventToDataLayer = (event, type = 'convForm', additional = {}) => {
      if (typeof window !== 'undefined' && window.dataLayer) {
        const eventContent = typeof event === 'object' ? event : {
          event: 'GA_event',
          eventAction: event,
          eventCategory: 'КонвергенцияForm',
          eventLabel: 'changeField',
          ...additional,
        };

        if (type === 'convForm') {
          window.dataLayer.push(eventContent);
        } else {
          window.dataLayer.push({
            ...eventContent,
            ordered_Type: this.props.withoutInternet ? 'New order' : 'Home User',
          });
        }
      }
    };

    handlePhoneChange = () => {
      if (!this.state.isPhonePushed) {
        this.setState({ isPhonePushed: true }, () => {
          this.pushEventToDataLayer('Phone');
        });
      }
    };

    handleDropDownChange = (value) => {
      if (this.state.selectedAddress !== value) {
        this.setState({
          selectedAddress: value,
        });
      }
    };

    submitHandler = (data) => {
      this.props.onSubmit(data);
    };

    validateAllFields = () => {
      if (!this.state.orderBtnClicked) {
        return;
      }
      const { region, street, house, flat } = this.props;

      this.setState({
        regionStatus: region && typeof region.id === 'number' ? 'ok' : 'fail',
        streetStatus: street && typeof street.id === 'number' ? 'ok' : 'fail',
        houseStatus: house && typeof house.id === 'number' ? 'ok' : 'fail',
        flatStatus: flat && flat.length > 0 ? 'ok' : 'fail',
      });
    };

    renderHeading = (address) => (
      <Heading level={4} className={cx('heading')}>
        {this.getHeader(address)}
      </Heading>
    );

    renderAddressDropdown = (withoutInternet, address) => {
      if (withoutInternet || !address) {
        return null;
      }
      return (
        <Dropdown
          options={[
            { value: 'default', label: address.description },
            { value: 'other', label: 'Другой адрес' },
          ]}
          value="default"
          onChange={this.handleDropDownChange}
          className={cx({ hidden: this.props.withoutInternet })}
        />
      );
    };

    render() {
      const {
        withoutInternet,
        region,
        street,
        house,
        flat,
        flatAlreadyUsed,
        isFlatPartnerConnected,
        isAddressCorrect,
        requestData,
        mobileTariffUrl,
        openRequestHousePopup,
      } = this.props;

      const {
        regionStatus,
        streetStatus,
        houseStatus,
        flatStatus,
      } = this.state;

      const selectedRegionId = region.id;

      const validator = {
        Address: (value) => {
          this.validateAllFields();
          return ({
            status: value && value.length > 0 ? 'ok' : 'fail',
            msg: 'Некорректно указан адрес',
          });
        },
      };

      const houseIsNotAvailable = house.id && !house.isConnected;
      return (
        <div>
          <SmartForm
            className={cx('form')}
            onSubmit={this.submitHandler}
            validator={{
              ContactNumber: maskedPhone,
              ...validator,
            }}
            inline
            autoComplete="off"
          >
            <SmartInput inputId="RegionId" name="RegionId" value={selectedRegionId} type="hidden" />
            <SmartInput inputId="NewStreetId" name="NewStreetId" value={street.id} type="hidden" />
            <SmartInput inputId="NewHouseId" name="NewHouseId" value={house.id} type="hidden" />
            <SmartInput inputId="NewFlat" name="NewFlat" value={flat} type="hidden" />
            <SmartInput
              inputId="Address"
              className={cx('hidden')}
              value={(!withoutInternet || isAddressCorrect) ? 'Address' : ''}
              type="hidden"
            />

            <AddressWrapper
              pushToAnalytics={this.pushEventToDataLayer}
              streetStatus={streetStatus}
              houseStatus={houseStatus}
              flatStatus={flatStatus}
              regionStatus={regionStatus}
            />
            <InputsRow className={['nested', 'small']} groups={2}>
              <InputGroup className={cx('inputGroup')}>
                <Label>{Ctx.allInOne.requestForm.phoneLabel}</Label>
                <SmartInput
                  name="ContactNumber"
                  inputId="ContactNumber"
                  mask="+7 ___ ___ __ __"
                  value="+7 "
                  autoComplete="off"
                  onChange={this.handlePhoneChange}
                  size="big"
                  keepInitialValue
                />
              </InputGroup>

              <InputGroup className={cx('inputGroup')}>
                <div className={cx('buttonWrapper')}>
                  {(houseIsNotAvailable) ? (
                    <Button
                      type="button"
                      href={`${mobileTariffUrl}?connect=true&ignoreDivorcing=true`}
                      className="big"
                      wide
                    >
                      {Ctx.allInOne.requestForm.btnWithoutHome}
                    </Button>
                  ) : (
                    <Button
                      disabled={flatAlreadyUsed || isFlatPartnerConnected}
                      type="submit"
                      onClick={this.onOrderClick}
                      className="big"
                      wide
                    >
                      {Ctx.allInOne.requestForm.buttonText}
                    </Button>
                  )}
                </div>
              </InputGroup>
            </InputsRow>

            {(houseIsNotAvailable) && (
            <div className={cx('requestHouseLinkWrap')}>
              <Link onClick={openRequestHousePopup}>
                {Ctx.allInOne.requestForm.connectHouseLink}
              </Link>
            </div>
            )}
          </SmartForm>

          {!requestData.IsSucceeded && requestData.ErrorMessage && (
            <Status
              emoji="statusFail"
              className={['wide', 'attention']}
            >
              {requestData.ErrorMessage}
            </Status>
          )}

          <div className={cx('termOfUse')}>
            <span dangerouslySetInnerHTML={{ __html: Ctx.allInOne.requestForm.userAgreementText }} />
            <Tooltip contentPosition="top">
              <span dangerouslySetInnerHTML={{ __html: Ctx.allInOne.requestForm.termsOfUse }} />
            </Tooltip>
          </div>
        </div>
      );
    }
}

FormWrapper.defaultProps = {
  withoutInternet: false,
  isAddressCorrect: true,
  flatAlreadyUsed: false,
  isFlatPartnerConnected: false,
  region: {},
  street: {},
  house: {},
  flat: '',
  requestData: {},
};

FormWrapper.propTypes = {
  withoutInternet: PropTypes.bool,
  isAddressCorrect: PropTypes.bool,
  flatAlreadyUsed: PropTypes.bool,
  isFlatPartnerConnected: PropTypes.bool,
  region: PropTypes.object,
  street: PropTypes.object,
  house: PropTypes.object,
  flat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  mobileTariffUrl: PropTypes.string,
  requestData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  openRequestHousePopup: PropTypes.func,
};

const makeMapStateToProps = () => {
  const mapFormData = (state, props) => makeFormData(state, props);

  return mapFormData;
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data) => dispatch(sendRequiest(data)),
  openRequestHousePopup: () => dispatch({
    type: SET_ALLINONE_VALUE,
    payload: {
      popupIsOpen: true,
      requestHouse: '',
    },
  }),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(FormWrapper);
